import { defer, Deferred, Promise } from 'q'

//
//
//

export type TaskStatus =
  | 'idle'
  | 'running'
  | 'success'
  | 'failure'
  | 'warning'
  | 'disabled'
  | 'canceled'

export interface Sequence {
  promise: Promise<unknown>
  cancel: () => void
}

export interface Task {
  run: () => Promise<unknown>
  cancel: () => void
}

type Tasks = Task[]

export const runAllSequentially = (tasks: Tasks): Sequence => {
  const deferred = defer()

  let rejected: any = null,
    stopOnFailure = false,
    current = -1

  function notify(tasks: any) {
    deferred.notify(tasks)
  }

  function reject() {
    notify(tasks)
    deferred.reject(rejected)
  }

  function resolve() {
    notify(tasks)
    deferred.resolve(tasks)
  }

  function cancel() {
    stopOnFailure = true

    if (tasks[current]) {
      tasks[current].cancel()
    }

    rejected = new Error('Canceled')
  }

  function runNext() {
    const length = tasks.length
    current++

    if (rejected && stopOnFailure) {
      reject()
    } else if (!length) {
      resolve()
    } else if (current === length) {
      //console.log('no more tasks', tasks, name);
      if (rejected) {
        reject()
      } else {
        resolve()
      }
    } else {
      //console.log('run task', current, tasks, name);
      try {
        notify(tasks[current])

        tasks[current].run().then(
          runNextAsync,
          (err: Error) => {
            rejected = rejected || err
            if (current === tasks.length && stopOnFailure) {
              reject()
            } else {
              runNextAsync()
            }
          },
          notify,
        )
      } catch (taskError) {
        rejected = taskError
        reject()
      }
    }
  }

  notify(tasks)

  const runNextAsync = setTimeout.bind(null, runNext)
  runNextAsync()

  return {
    cancel: cancel,
    promise: deferred.promise,
  }
}
